import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductCarouselComponent } from '@sdvor/product/ui/v2';
import { BreadcrumbsComponent } from '@sdvor/seo/ui';
import {
  OrderConfirmationInfoBodyComponent,
  OrderConfirmationInfoButtonsComponent,
  OrderConfirmationInfoInvoiceButtonComponent,
  OrderConfirmationInfoTitleComponent,
} from '../../components/order-confirmation-info';

@Component({
  selector: 'sd-order-confirmation-page',
  imports: [
    BreadcrumbsComponent,
    ProductCarouselComponent,
    OrderConfirmationInfoTitleComponent,
    OrderConfirmationInfoBodyComponent,
    OrderConfirmationInfoButtonsComponent,
    OrderConfirmationInfoInvoiceButtonComponent,
  ],
  templateUrl: './order-confirmation-page.component.html',
  styleUrl: './order-confirmation-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderConfirmationPageComponent {}
